/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdDomainSettingsFacebookPublicAuthOptions interface.
 */
export function instanceOfFxIdDomainSettingsFacebookPublicAuthOptions(value) {
    if (!('AppId' in value) || value['AppId'] === undefined)
        return false;
    if (!('AsidInternalErrorRecoveryEnabled' in value) || value['AsidInternalErrorRecoveryEnabled'] === undefined)
        return false;
    if (!('AsidInternalErrorRecoveryProtocolVersion' in value) || value['AsidInternalErrorRecoveryProtocolVersion'] === undefined)
        return false;
    return true;
}
export function FxIdDomainSettingsFacebookPublicAuthOptionsFromJSON(json) {
    return FxIdDomainSettingsFacebookPublicAuthOptionsFromJSONTyped(json, false);
}
export function FxIdDomainSettingsFacebookPublicAuthOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'AppId': json['AppId'],
        'AsidInternalErrorRecoveryEnabled': json['AsidInternalErrorRecoveryEnabled'],
        'AsidInternalErrorRecoveryProtocolVersion': json['AsidInternalErrorRecoveryProtocolVersion'],
    };
}
export function FxIdDomainSettingsFacebookPublicAuthOptionsToJSON(json) {
    return FxIdDomainSettingsFacebookPublicAuthOptionsToJSONTyped(json, false);
}
export function FxIdDomainSettingsFacebookPublicAuthOptionsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'AppId': value['AppId'],
        'AsidInternalErrorRecoveryEnabled': value['AsidInternalErrorRecoveryEnabled'],
        'AsidInternalErrorRecoveryProtocolVersion': value['AsidInternalErrorRecoveryProtocolVersion'],
    };
}
//# sourceMappingURL=FxIdDomainSettingsFacebookPublicAuthOptions.js.map